import { render, staticRenderFns } from "./LiveTrade.vue?vue&type=template&id=0346af8a&scoped=true"
import script from "./LiveTrade.vue?vue&type=script&lang=js"
export * from "./LiveTrade.vue?vue&type=script&lang=js"
import style0 from "./LiveTrade.vue?vue&type=style&index=0&id=0346af8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0346af8a",
  null
  
)

export default component.exports